<template>
  <div class="">
    <b-button v-b-toggle.placesWorkPlans class="btn btn-lg btn-collapse">
      {{ $t("placesWorkPlans.placesWorkPlans") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="placesWorkPlans">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placesWorkPlansView"
              v-model="usersPrivilegePlacesWorkPlans.placesWorkPlansView"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placesWorkPlansView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placesWorkPlansAdd"
              v-model="usersPrivilegePlacesWorkPlans.placesWorkPlansAdd"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placesWorkPlansAdd">{{
              $t("add")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placesWorkPlansUpdate"
              v-model="usersPrivilegePlacesWorkPlans.placesWorkPlansUpdate"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placesWorkPlansUpdate">{{
              $t("edit")
            }}</label>
          </div>

          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placesWorkPlansArchive"
              v-model="usersPrivilegePlacesWorkPlans.placesWorkPlansArchive"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placesWorkPlansArchive">{{
              $t("archive")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placesWorkPlansDelete"
              v-model="usersPrivilegePlacesWorkPlans.placesWorkPlansDelete"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placesWorkPlansDelete">{{
              $t("finalDelete")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placesWorkPlansRestore"
              v-model="usersPrivilegePlacesWorkPlans.placesWorkPlansRestore"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placesWorkPlansRestore">{{
              $t("restore")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegePlacesWorkPlans",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegePlacesWorkPlans"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
